<template>
    <v-container fluid class="divs">
        <v-card>
            <v-toolbar dark color="secondary" class="white--text" dense>
                <v-spacer></v-spacer>
                <v-toolbar-title>
                    Grouping Rates
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-container fluid>
                <v-form ref="form" lazy-validation>
                    <v-row>
                        <v-col cols="5">
                            <v-combobox
                                v-model="rate"
                                :items="rates"
                                @change="loadGrupingByRate"
                                :item-text="'Text'"
                                :item-value="'RateId'"
                                label="RateId"
                                append-outer-icon="mdi-plus-circle"
                                @click:append-outer="validate"
                                dense
                                hide-details
                            ></v-combobox>
                        </v-col>
                    </v-row>
                </v-form>
                <v-container grid-list-xs fluid>
                    <v-data-table dense :headers="headers" :items="priority">
                        <template v-slot:item.RateFH="{ item }">
                            <v-combobox
                                v-model="item.RateFH"
                                :items="rates"
                                :item-text="'Text'"
                                :item-value="'RateId'"
                                @change="switchPriority(item, 'FHRateID')"
                                dense
                                hide-details
                            ></v-combobox>
                        </template>
                        <template v-slot:item.Truck="{ item }">
                            <v-combobox
                                v-model="item.Truck"
                                :items="trucks"
                                :item-text="'Truck'"
                                :item-value="'TruckID'"
                                @change="switchPriority(item, 'Truck')"
                                dense
                                hide-details
                            ></v-combobox>
                        </template>
                        <template v-slot:item.FHRate="{ item }">
                            <v-text-field
                                type="number"
                                dense
                                hide-details
                                @change="switchPriority(item, 'FHRate')"
                                v-model="item.FHRate"
                            ></v-text-field>
                        </template>
                        <template v-slot:item.BHRate="{ item }">
                            <v-text-field
                                type="number"
                                dense
                                hide-details
                                @change="switchPriority(item, 'BHRate')"
                                v-model="item.BHRate"
                            ></v-text-field>
                        </template>
                        <template v-slot:item.Priority="{ item }">
                            <v-text-field
                                type="number"
                                dense
                                hide-details
                                @change="switchPriority(item, 'Priority')"
                                v-model="item.Priority"
                            ></v-text-field>
                        </template>
                        <template v-slot:item.Action="{ item }">
                            <v-btn
                                color="red"
                                icon
                                @click="deletePriority(item)"
                                ><v-icon>mdi-delete</v-icon></v-btn
                            >
                        </template>
                        <template v-slot:item.Yard="{ item }">
                            <v-combobox
                                v-model="item.Yard"
                                :items="yards"
                                :item-text="'Yard'"
                                :item-value="'id'"
                                @change="switchPriority(item, 'Yard')"
                                dense
                                hide-details
                            ></v-combobox>
                        </template>
                    </v-data-table>
                </v-container>
            </v-container>
        </v-card>
    </v-container>
</template>

<script>
import axios from 'axios';
import { mask } from 'vue-the-mask';
export default {
    directives: { mask },
    data: function() {
        return {
            terminal: '',
            station: '',
            rates: [],
            rate: null,
            rateId: '',
            trucks: [],
            yards: [],
            FBHTypes: [
                { id: 1, Type: 'FHRate' },
                { id: 2, Type: 'BHRate' }
            ],
            groups: [],
            headers: [
                { text: 'FBH RateID', value: 'RateFH', width: '35%' },
                { text: 'Terminal', value: 'Terminal' },
                { text: 'Station', value: 'Station' },
                { text: 'Truck', value: 'Truck', width: '10%' },
                { text: 'FHRate', value: 'FHRate', width: '10%' },
                { text: 'Priority', value: 'Priority', width: '10%' },
                { text: 'Yard', value: 'Yard', width: '10%' },
                { text: 'Action', value: 'Action', width: '10%' }
            ],
            priority: []
        };
    },
    mounted() {
        this.loadRates();
        this.loadTrucks();
        this.loadYards();
    },
    methods: {
        loadTrucks: function() {
            this.$store.state.isLoading = true;
            var str = this.$store;
            axios
                .get('truck/active', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.trucks = response.data;
                    console.log(this.trucks);
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        loadYards: function() {
            this.$store.state.isLoading = true;
            var str = this.$store;
            axios
                .get('yard/active')
                .then(response => {
                    this.yards = response.data.data;
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },
        loadGrupingByRate: function() {
            var str = this.$store;
            console.log(this.rate);
            if (this.rate != null) {
                str.state.isLoading = true;
                axios
                    .get('group-rate/by/' + this.rate.RateId)
                    .then(response => {
                        this.priority = response.data;
                        // for (const item of  this.priority) {
                        // }
                        this.priority.forEach(elm => {
                            var idxFH = this.rates.findIndex(x => {
                                return x.RateId == elm.FHRateID;
                            });
                            elm['RateFH'] = this.rates[idxFH];

                            var idxYard = this.yards.findIndex(x => {
                                return x.id == elm.YardId;
                            });
                            elm['Yard'] = this.yards[idxYard];

                            var idxTruck = this.trucks.findIndex(x => {
                                return x.TruckID == elm.TruckId;
                            });
                            console.log(idxTruck);
                            elm['Truck'] = this.trucks[idxTruck];
                        });

                        console.log(this.priority);
                        str.state.isLoading = false;
                    })
                    .catch(function(error) {
                        str.state.isLoading = false;
                        console.log(error);
                        if (error.response.status === 403) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'You do not have the permission to use this function.'
                            });
                        }
                        if (error.response.status === 500) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text: 'An error has ocurred, please try again.'
                            });
                        }
                    });
            }
        },
        switchPriority: async function(item, field) {
            var parms = {};
            var rate = null;
            var yard = null;
            var truck = null;
            switch (field) {
                case 'FHRate':
                    parms = {
                        FHRate: item.FHRate
                    };
                    break;
                case 'Priority':
                    parms = {
                        Priority: item.Priority
                    };
                    break;
                case 'Truck':
                    if (item.Truck != null) {
                        truck = item.Truck.TruckID;
                    }
                    parms = {
                        TruckId: truck
                    };
                    break;
                case 'Yard':
                    if (item.Yard != null) {
                        yard = item.Yard.id;
                    }
                    parms = {
                        YardId: yard
                    };
                    break;
                case 'FHRateID':
                    if (item.RateFH != null) {
                        rate = item.RateFH.RateId;
                        item.Terminal = item.RateFH.Terminal;
                        item.Station = item.RateFH.Station;
                    }

                    parms = {
                        FHRateID: rate
                    };
                    break;
            }
            this.updateGrouping(parms, item.GroupRateID);
        },
        updateGrouping: function(parms, id) {
            var str = this.$store;
            axios
                .put('group-rate/' + id, parms)
                .then(response => {
                    console.log(response.data);
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Change saved successfully'
                    });
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        loadRates: function() {
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .get('group-rate/all/rates')
                .then(response => {
                    this.rates = response.data;
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },
        validate: async function() {
            var str = this.$store;
            if (this.rate != null) {
                this.addPriority();
            } else {
                str.dispatch('setSnackbar', {
                    color: '#e6ac00',
                    text: 'Enter a RateId'
                });
            }
        },
        addPriority: function() {
            var str = this.$store;
            str.state.isLoading = true;
            var parms = {
                RateId: this.rate.RateId
            };
            axios
                .post('group-rate', parms)
                .then(response => {
                    console.log(response.data);
                    this.loadGrupingByRate();
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    str.state.isLoading = false;
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        deletePriority: function(itm) {
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .delete('group-rate/' + itm.GroupRateID)
                .then(response => {
                    console.log(response.data);
                    this.loadGrupingByRate();
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    str.state.isLoading = false;
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        }
    }
};
</script>

<style>
.divs {
    margin-top: 0px;
    padding-top: 0px;
}

.chps {
    width: 10px;
}
</style>
